import { Injectable } from '@angular/core';
import storage from 'local-storage-fallback';

@Injectable()
export class Globals {
  token: string = JSON.parse(storage.getItem("currentUser")) ? JSON.parse(storage.getItem("currentUser")).token : "";
  // apiEndpoint: string = 'http://localhost:3000/api/v1';
  apiEndpoint: string = 'https://apiv2.imt-pm.com/api/v1';
  apiImageEndpoint: string =  'https://d2mzr68e3gyzke.cloudfront.net';
  siteUrl: string = 'https://elearning.imt-pm.com.com';


  siteName: string = "Online Certification Training Courses - IMT-PM";
  analystic: string = "UA-129774692-1";
  wid: null;
  user: null;
  checkingRefreshToken: boolean = false;
  courseCategories = [
  	{value: 0, label: 'Business & Management'}, 
  	{value: 1, label: 'Creative Arts & Media'}, 
  	{value: 2, label: 'Health & Psychology'}, 
  	{value: 3, label: 'History'}, 
  	{value: 4, label: 'Languages & Cultures'}, 
  	{value: 5, label: 'Law'}, 
  	{value: 6, label: 'Literature'}, 
    {value: 7, label: 'Nature & Environment'}, 
  	{value: 8, label: 'Politics & the Modern World'}, 
    {value: 9, label: 'Science, Engineering & Maths'},
  	{value: 10, label: 'Study Skill'},
  	{value: 11, label: 'Teaching'}, 
  	{value: 12, label: 'Tech & Coding'}
  ];
}